export const { gettext } = window
